(function () {

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequireda16"];
var parcelRegister = parcelRequire.register;
parcelRegister("cqXmx", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "useUrlTransformer", function () { return $90d5f5e5c225a7f6$export$35346fa89da2bdc9; });
$parcel$export(module.exports, "Content", function () { return $90d5f5e5c225a7f6$export$7c6e2c02157bb7d2; });
$parcel$export(module.exports, "make", function () { return $90d5f5e5c225a7f6$export$dd44f18ab656f3bb; });
$parcel$export(module.exports, "$$default", function () { return $90d5f5e5c225a7f6$export$aa541d093b11ace2; });
$parcel$export(module.exports, "default", function () { return $90d5f5e5c225a7f6$export$aa541d093b11ace2; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $8u0V4 = parcelRequire("8u0V4");

var $7KlbQ = parcelRequire("7KlbQ");

var $kJhYp = parcelRequire("kJhYp");

var $bygWp = parcelRequire("bygWp");

var $ePRCc = parcelRequire("ePRCc");

var $efwy1 = parcelRequire("efwy1");

var $hBcYV = parcelRequire("hBcYV");

var $bZsVp = parcelRequire("bZsVp");

var $37BLX = parcelRequire("37BLX");

var $cdK26 = parcelRequire("cdK26");

var $2ZaET = parcelRequire("2ZaET");

var $9pMGg = parcelRequire("9pMGg");

var $Tbt6s = parcelRequire("Tbt6s");

var $dhngN = parcelRequire("dhngN");

var $8adqh = parcelRequire("8adqh");

var $8E2YL = parcelRequire("8E2YL");

var $b8WNX = parcelRequire("b8WNX");
function $90d5f5e5c225a7f6$export$35346fa89da2bdc9(enabledOpt, param) {
    var enabled = enabledOpt !== undefined ? enabledOpt : true;
    $8E2YL.use(undefined);
    var match = $efwy1.use(undefined);
    var setUrlTransformer = match.setUrlTransformer;
    var namespace = match.namespace;
    var match$1 = $9pMGg.use(undefined);
    var smartnavApiHost = match$1.smartnavApiHost;
    var match$2 = $8u0V4.getValues(match$1.market);
    var country = match$2.country;
    var currency = match$2.currency;
    var urlTransformer = function urlTransformer(loc, baseUrl) {
        var productId = $2whNH.flatMap(loc.quickNav, function(nav) {
            return nav.productId;
        });
        var variantId = $2whNH.flatMap(loc.quickNav, function(nav) {
            return nav.variantId;
        });
        var product = $2whNH.flatMap(productId, function(pi) {
            return $bZsVp.getProductById(smartnavApiHost, currency, country, pi);
        });
        var variant = $2whNH.flatMap(variantId, function(vi) {
            return $2whNH.flatMap(product, function(p) {
                return $i7mYY.getBy($7KlbQ.getAllVariants(p), function(v) {
                    return v.id === vi;
                });
            });
        });
        var newUrl = variant !== undefined ? $2whNH.flatMap(variant.link, $bygWp.maybeMakeUrl) : product !== undefined ? $2whNH.flatMap(product.link, $bygWp.maybeMakeUrl) : undefined;
        return $2whNH.map($2whNH.map($2whNH.keep(newUrl, function(newUrl) {
            return newUrl.hostname === baseUrl.hostname;
        }), function(newUrl) {
            newUrl.protocol = baseUrl.protocol;
            return newUrl;
        }), function(newUrl) {
            return new URL($kJhYp.toBaseUrl(namespace, newUrl.href));
        });
    };
    $g85JO.useEffect(function() {
        if (enabled) $iv6Yc._1(setUrlTransformer, function(param) {
            return urlTransformer;
        });
        return function(param) {
            $iv6Yc._1(setUrlTransformer, function(param) {});
        };
    }, [
        namespace,
        enabled
    ]);
}
function $90d5f5e5c225a7f6$var$PDPApp$Content(Props) {
    var attributes = Props.attributes;
    var match = $hBcYV.useRouter(undefined);
    var shopifyProductId = $cdK26.getProductPageProductId(undefined);
    var productId = $2whNH.orElse(match.anyProductId, shopifyProductId);
    var showLauncher = $2whNH.getWithDefault($2whNH.flatMap(attributes, function(attr) {
        return attr.pdpShowLauncher;
    }), true);
    $90d5f5e5c225a7f6$export$35346fa89da2bdc9($cdK26.isProductPage(undefined), undefined);
    if (productId !== undefined) return /*#__PURE__*/ $g85JO.createElement($Tbt6s.make, {
        productId: productId,
        showLauncher: showLauncher
    });
    else return null;
}
$90d5f5e5c225a7f6$var$PDPApp$Content.displayName = "PDPApp.Content";
var $90d5f5e5c225a7f6$export$7c6e2c02157bb7d2 = {
    make: $90d5f5e5c225a7f6$var$PDPApp$Content
};
function $90d5f5e5c225a7f6$var$PDPApp(Props) {
    var attributes = Props.attributes;
    var embedType = Props.embedType;
    var match = $hBcYV.useRouter(undefined);
    var match$1 = $8E2YL.use(undefined);
    var config = match$1.config;
    var match$2 = $efwy1.use(undefined);
    var namespace = match$2.namespace;
    var pageOnlyHasPDP = $37BLX.countBottombarElementsByNamespace(namespace) === 0 && $37BLX.countInlineElementsByNamespace(namespace) === 0 && $37BLX.countLauncherElementsByNamespace(namespace) === 0 && $37BLX.countSectionElementsByNamespace(namespace) === 0;
    var tmp = {
        config: config,
        embedType: embedType,
        children: null
    };
    if (attributes !== undefined) tmp.attributes = $loT9g.valFromOption(attributes);
    var tmp$1;
    var tmp$2 = match.route;
    tmp$1 = typeof tmp$2 === "number" || !(tmp$2.TAG === /* QuickView */ 3 && pageOnlyHasPDP) ? null : /*#__PURE__*/ $g85JO.createElement($b8WNX.make, {});
    var tmp$3 = {};
    if (attributes !== undefined) tmp$3.attributes = $loT9g.valFromOption(attributes);
    return /*#__PURE__*/ $g85JO.createElement($ePRCc.make, {
        initiator: "pdp",
        portal: false,
        children: /*#__PURE__*/ $g85JO.createElement($dhngN.make, tmp, tmp$1, /*#__PURE__*/ $g85JO.createElement($90d5f5e5c225a7f6$var$PDPApp$Content, tmp$3), /*#__PURE__*/ $g85JO.createElement($2ZaET.When.make, {
            condition: config.settings.cart,
            children: /*#__PURE__*/ $g85JO.createElement($8adqh.make, {})
        }))
    });
}
$90d5f5e5c225a7f6$var$PDPApp.displayName = "PDPApp";
var $90d5f5e5c225a7f6$export$dd44f18ab656f3bb = $90d5f5e5c225a7f6$var$PDPApp;
var $90d5f5e5c225a7f6$export$aa541d093b11ace2 = $90d5f5e5c225a7f6$var$PDPApp;
 /* react Not a pure module */ 
});
parcelRegister("37BLX", function(module, exports) {

$parcel$export(module.exports, "countInlineElementsByNamespace", function () { return $245f535c80fa97b7$export$7460c80d7c5cf75c; });
$parcel$export(module.exports, "countBottombarElementsByNamespace", function () { return $245f535c80fa97b7$export$3a44f3abf1840775; });
$parcel$export(module.exports, "countLauncherElementsByNamespace", function () { return $245f535c80fa97b7$export$ac754b9504a93a08; });
$parcel$export(module.exports, "countSectionElementsByNamespace", function () { return $245f535c80fa97b7$export$b75c7a415a35e365; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $d3YYW = parcelRequire("d3YYW");

var $7bjme = parcelRequire("7bjme");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $h6rW7 = parcelRequire("h6rW7");
function $245f535c80fa97b7$export$36d3479b5d03ac38(el) {
    var namespace = el.getAttribute("data-namespace");
    if (namespace == null) return $h6rW7.empty;
    else return $h6rW7.fromString(namespace);
}
function $245f535c80fa97b7$export$d0ebfc305a7a6844(elements, namespace) {
    var namespace$1 = $2whNH.getWithDefault(namespace, $h6rW7.empty);
    return $i7mYY.keep($2whNH.getWithDefault($2whNH.map(elements, $d3YYW.values), []), function(element) {
        return $7bjme.equal($245f535c80fa97b7$export$36d3479b5d03ac38(element), namespace$1);
    });
}
function $245f535c80fa97b7$export$a82d8d7911f406ff(namespace) {
    return $245f535c80fa97b7$export$d0ebfc305a7a6844(window.smartNavElementsInline, namespace);
}
function $245f535c80fa97b7$export$310f9fbcf0732046(namespace) {
    return $245f535c80fa97b7$export$d0ebfc305a7a6844(window.smartNavElements, namespace);
}
function $245f535c80fa97b7$export$677c1fd84b0cad4f(namespace) {
    return $245f535c80fa97b7$export$d0ebfc305a7a6844(window.smartNavElementsLauncher, namespace);
}
function $245f535c80fa97b7$export$bbd7846266bc9fe8(namespace) {
    return $245f535c80fa97b7$export$d0ebfc305a7a6844(window.smartNavElementsSection, namespace);
}
function $245f535c80fa97b7$export$58368f7b4fc9b76d(namespace) {
    return $245f535c80fa97b7$export$d0ebfc305a7a6844(window.smartNavElementsPDP, namespace);
}
function $245f535c80fa97b7$export$7460c80d7c5cf75c(namespace) {
    return $245f535c80fa97b7$export$d0ebfc305a7a6844(window.smartNavElementsInline, namespace).length;
}
function $245f535c80fa97b7$export$3a44f3abf1840775(namespace) {
    return $245f535c80fa97b7$export$d0ebfc305a7a6844(window.smartNavElements, namespace).length;
}
function $245f535c80fa97b7$export$ac754b9504a93a08(namespace) {
    return $245f535c80fa97b7$export$d0ebfc305a7a6844(window.smartNavElementsLauncher, namespace).length;
}
function $245f535c80fa97b7$export$b75c7a415a35e365(namespace) {
    return $245f535c80fa97b7$export$d0ebfc305a7a6844(window.smartNavElementsSection, namespace).length;
}
function $245f535c80fa97b7$export$65ea36736e2b48c7(namespace) {
    return $245f535c80fa97b7$export$d0ebfc305a7a6844(window.smartNavElementsPDP, namespace).length;
}
 /* No side effect */ 
});

parcelRegister("8adqh", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $5f19ab6e1e369baa$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $g85JO = parcelRequire("g85JO");

var $7tAuM = parcelRequire("7tAuM");

var $5f19ab6e1e369baa$var$component = (0, $7tAuM.default)(function() {
    return (parcelRequire("9E7Ru"));
});
function $5f19ab6e1e369baa$var$MiniCartDrawer_Lazy(Props) {
    return /*#__PURE__*/ $g85JO.createElement($5f19ab6e1e369baa$var$component, Props);
}
$5f19ab6e1e369baa$var$MiniCartDrawer_Lazy.displayName = "MiniCartDrawer_Lazy";
var $5f19ab6e1e369baa$export$dd44f18ab656f3bb = $5f19ab6e1e369baa$var$MiniCartDrawer_Lazy;
 /*  Not a pure module */ 
});
parcelRegister("9E7Ru", function(module, exports) {












module.exports = Promise.all([
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("by1hz")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("fW0Yj")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("6zo4Z")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("6Tuh6")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("519fX")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("ebd07"))
]).then(function() {
    return parcelRequire("67Br4");
});

});


parcelRegister("b8WNX", function(module, exports) {

$parcel$export(module.exports, "preload", function () { return $81ce0e7d77235b59$export$513ccb98c53b8039; });
$parcel$export(module.exports, "make", function () { return $81ce0e7d77235b59$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $g85JO = parcelRequire("g85JO");

var $7tAuM = parcelRequire("7tAuM");

var $81ce0e7d77235b59$var$component = (0, $7tAuM.default)(function() {
    return (parcelRequire("ib7cK"));
});
function $81ce0e7d77235b59$var$QuickViewOverlay_Lazy(Props) {
    return /*#__PURE__*/ $g85JO.createElement($81ce0e7d77235b59$var$component, Props);
}
$81ce0e7d77235b59$var$QuickViewOverlay_Lazy.displayName = "QuickViewOverlay_Lazy";
var $81ce0e7d77235b59$export$513ccb98c53b8039 = $81ce0e7d77235b59$var$component.preload;
var $81ce0e7d77235b59$export$dd44f18ab656f3bb = $81ce0e7d77235b59$var$QuickViewOverlay_Lazy;
 /*  Not a pure module */ 
});
parcelRegister("ib7cK", function(module, exports) {














module.exports = Promise.all([
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("fW0Yj")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("i1uwo")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("1YO94")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("6zo4Z")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("6Tuh6")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("519fX")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("3pqCl"))
]).then(function() {
    return parcelRequire("1xMeg");
});

});



parcelRegister("hQWQG", function(module, exports) {

$parcel$export(module.exports, "ContentId", function () { return $cff4f11bdb1bf2d0$export$bb6896aa5755c251; });
$parcel$export(module.exports, "SectionId", function () { return $cff4f11bdb1bf2d0$export$9bbe9bfd3294dd44; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $ki9MN = parcelRequire("ki9MN");
var $cff4f11bdb1bf2d0$export$bb6896aa5755c251 = $ki9MN.Make({});
var $cff4f11bdb1bf2d0$export$9bbe9bfd3294dd44 = $ki9MN.Make({});
 /* ContentId Not a pure module */ 
});

})();
//# sourceMappingURL=PDPApp.bs.a399d7b7.js.map
